module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cAPUV"))).then(() => parcelRequire('ikE14'));